import { actionType } from "../actions/nasjonerActions";
import * as reducerUtils from "../utils/reducerUtils";

const INITIAL_STATE = [];
const nasjonerReducer = (state = INITIAL_STATE, action) =>
  reducerUtils.CreateNewReducer(state, action, actionType);

export default nasjonerReducer;
